import { Component, Input, OnInit, EventEmitter, Output, Inject } from "@angular/core";
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface DialogData {
  user_id: any;
  manageData: any;
  companyId: any;
}

@Component({
  selector: 'app-client-edit',
  templateUrl: './client-edit.component.html',
  styleUrls: ['./client-edit.component.css']
})
export class ClientEditComponent implements OnInit {

  clientForm: FormGroup;
  public status = "";
  public disabled = true;
  @Output() toggleForm = new EventEmitter<boolean>();
  public result = "";
  public selectedFile = null;
  public activeClass = 'active';
  public path = null;
  public image_path = null;
  public checkImage = null;
  public extension = null;
  private checkImageStatus = null;
  public companyId = null;
  locationOptions = [
    { value: '', viewValue: 'Choose your option' },
    { value: "Yes", viewValue: "Yes" },
    { value: "No", viewValue: "No" }

  ];
  paymentTermOptions = [
    { value: '', viewValue: 'Choose your option' },
    { value: "Yes", viewValue: "Yes" },
    { value: "No", viewValue: "No" }

  ];
  constructor(private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private CommonService: CommonService,
    public dialogRef: MatDialogRef<ClientEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.companyId = this.data.companyId ? this.data.companyId : null;
  }

  ngOnInit() {
    this.clientForm = this.formBuilder.group({
      company_name: [null],
      site_url: [null, Validators.pattern('https?://.+')], //[null, Validators.pattern('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$')],
      first_name: [null, Validators.required],
      last_name: [null, Validators.required],
      middle_name: [null],
      email: [null, [Validators.email, Validators.required]],
      phone: [null],
      username: [null, Validators.minLength(5)],
      tax_exempt: [null, Validators.required],
      //federal_tax_id: [null],
      state_reseller_license: [null],
      tax_exempt_certificate: [null],
      is_payment_term: [null, Validators.required],
      net_days: [null]
    });

    if (this.data.manageData) {
      this.disabled = this.data.manageData.tax_status == "Approve" ? true : false;
      this.clientForm.setValue({
        'company_name': this.data.manageData.company_name ? this.data.manageData.company_name : '',
        'first_name': this.data.manageData.first_name,
        'middle_name': this.data.manageData.middle_name ? this.data.manageData.middle_name : '',
        'last_name': this.data.manageData.last_name,
        'email': this.data.manageData.email ? this.data.manageData.email : '',
        'phone': (this.data.manageData.phone && this.data.manageData.phone != "null" && this.data.manageData.phone != null && this.data.manageData.phone != "") ? this.data.manageData.phone.replace(/-/g, "") : '',
        'username': this.data.manageData.username,
        'site_url': this.data.manageData.site_url ? this.data.manageData.site_url : '',
        'tax_exempt': this.data.manageData.tax_exempt,
        //'federal_tax_id': this.data.manageData.federal_tax_id ? this.data.manageData.federal_tax_id : '',
        'state_reseller_license': this.data.manageData.state_reseller_license ? this.data.manageData.state_reseller_license : '',
        'tax_exempt_certificate': '',
        'is_payment_term': this.data.manageData.is_payment_term,
        'net_days': this.data.manageData.net_days
      });
      if (this.data.manageData.tax_exempt_certificate) {
        this.image_path = this.data.manageData.tax_exempt_certificate;
        this.checkImage = this.data.manageData.tax_exempt_certificate;
        this.extension = this.image_path.split('.').pop();
      }
    }
  }
  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    var render = new FileReader();
    render.onload = (event: any) => {
      this.image_path = event.target.result;
      this.extension = this.selectedFile.name.split('.').pop();
      this.extension = this.extension == 'pdf' ? null : this.extension;
    }
    render.readAsDataURL(this.selectedFile);

  }

  backToList(): void {
    this.toggleForm.emit();
  }

  isFieldValid(field: string) {
    return (
      !this.clientForm.get(field).valid &&
      this.clientForm.get(field).touched
    );
  }

  displayFieldCss(field: string) {
    return {
      "has-error": this.isFieldValid(field),
      "has-feedback": this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  saveClientData(postData) {
    this.dialogRef.close(postData);
  }
  onNoClick() {
    this.dialogRef.close(this.result);
  }
  updateClientFormData = function (postData) {
    if (this.clientForm.valid) {
      // this.clientOptions = {
      //   id: this.data.manageData.user_id,
      //   company_name: postData.company_name,
      //   first_name: postData.first_name,
      //   last_name: postData.last_name,
      //   middle_name: postData.middle_name,
      //   site_url: postData.site_url,
      //   email: postData.email,
      //   phone: postData.phone,
      //   tax_exempt: postData.tax_exempt,
      //   federal_tax_id: postData.federal_tax_id,
      //   state_reseller_license: postData.state_reseller_license,
      //   tax_exempt_certificate:this.selectedFile     

      // };

      const formData = new FormData();
      formData.append('id', this.data.manageData.user_id);
      formData.append('company_name', postData.company_name);
      formData.append('first_name', postData.first_name);
      formData.append('last_name', postData.last_name);
      formData.append('middle_name', postData.middle_name);
      formData.append('site_url', postData.site_url);
      formData.append('email', postData.email);
      formData.append('phone', postData.phone);
      formData.append('tax_exempt', postData.tax_exempt);
      //formData.append('federal_tax_id', postData.federal_tax_id);
      formData.append('state_reseller_license', postData.state_reseller_license);
      formData.append('is_payment_term', postData.is_payment_term);
      if (postData.is_payment_term == "Yes") {
        if (postData.net_days > 0) {
          formData.append('net_days', postData.net_days);
        }
        else {
          this._flashMessagesService.show("Please enter net days greater than 0", {
            cssClass: "alert-warning",
            timeout: 5000
          });
          return
        }
      }

      if (this.selectedFile) {
        formData.append('tax_exempt_certificate', this.selectedFile, this.selectedFile.name);
      }

      this.CommonService.apiService(
        "POST",
        "user/edit",
        formData
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.checkImageStatus = "saved";
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
            this.result = "success";

          }
          window.scrollTo(0, 0);
        },
        err => {
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.clientForm);
    }
  };

  deleteCertificate = function () {
    if (this.checkImage != null || this.checkImageStatus == "saved") {
      this.clientOptions = {};
      let user_id = this.data.manageData.user_id;
      let id = localStorage.getItem("userID");
      this.CommonService.apiService(
        "DELETE",
        "tax/certificate/" + id + "/" + user_id,
        this.clientOptions
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.image_path = null;
            this.checkImage = null;
            this.result = "success";
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });

          }
        },
        err => {
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-danger",
            timeout: 5000
          });
        }
      );
    }
    else {
      this.image_path = null;
      this.checkImage = null;
      this._flashMessagesService.show("User tax certificate file has been deleted successfully.", {
        cssClass: "alert-success",
        timeout: 5000
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/client-edit/client-edit.component.ts